import React, { Children, cloneElement, isValidElement, ReactElement } from 'react'

import { Spacing } from '../../enums/spacing'
import { ComponentsGroup, ComponentsGroupProps } from '../ComponentsGroup'

export type TagsGroupProps = Omit<ComponentsGroupProps, 'spacing'> & {
  merged?: boolean
}

export const TagsGroup = ({ merged, children, ...rest }: TagsGroupProps): ReactElement => {
  const spacing = !merged ? Spacing.S6 : undefined

  return (
    <ComponentsGroup {...rest} spacing={spacing} merged={merged}>
      {Children.map(children, (child) => isValidElement(child) && cloneElement(child))}
    </ComponentsGroup>
  )
}
